import { render, staticRenderFns } from "./MonthlyDocuments.vue?vue&type=template&id=4ae8fce8&scoped=true"
import script from "./MonthlyDocuments.vue?vue&type=script&scoped=true&lang=js"
export * from "./MonthlyDocuments.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./MonthlyDocuments.vue?vue&type=style&index=0&id=4ae8fce8&prod&scoped=true&lang=css"
import style1 from "./MonthlyDocuments.vue?vue&type=style&index=1&id=4ae8fce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8fce8",
  null
  
)

export default component.exports